// Tanner Fry
// tfry@monetagroup.com
// File contains constants for developers.

export const devConstantsTS = {
    GET_SEND_TEST_EMAIL_SUCCESS: "GET_SEND_TEST_EMAIL_SUCCESS",
    GET_SEND_TEST_EMAIL_FAILURE: "GET_SEND_TEST_EMAIL_FAILURE",
}